import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * ScrollToTop component that scrolls the window to the top when the route changes
 */
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export default ScrollToTop;